module.exports = __webpack_public_path__ + "fonts/e8531d0576f2c5faff5281a972bf1624.eot";